<template>
    <FilterLayout :advanceOption="false">
      <div class="mt-3">
        <h5 class="text-base font-normal leading-none text-theme-33">
          วันที่จัดทำข้อมูล
        </h5>
      </div>
      <DateRange v-model="filterByDate"/>
      <div class="mt-3">
        <h5 class="text-base font-normal leading-none text-theme-33">
          ระดับ
        </h5>
      </div>
      <v-select
        class="mt-1"
        data-test="level-select"
        id="level-select"
        v-model="selectedLevel"
        :options="['จังหวัด','สสว.']"
        :appendToBody="true"
        :clearable="false"
        :searchable="false"
        :disabled="getAllowActionByCurrRole('disabled-report-level-search')"
      >
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
      <OsmSection v-model="filterState.osm" v-if="selectedLevel == 'สสว.'"/>
      <AddressSection
        v-else
        :province="filterState.address.province"
        :amphur="filterState.address.amphur"
        :tumbol="filterState.address.tumbol"
        :village="filterState.address.village"
        @update:province="updateAddress($event, 'province')"
        @update:amphur="updateAddress($event, 'amphur')"
        @update:tumbol="updateAddress($event, 'tumbol')"
        @update:village="updateAddress($event, 'village')"
        parentComponent="report"
        key="report"
        :headerTitle="''"
        :disabledProvince="getAllowActionByCurrRole('disabled-report-province-search')"
      />
        <div class="flex justify-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="resetState">
                ล้าง
            </button>
            <button class="btn btn-primary" @click="sendToStore">
                ค้นหา
            </button>
        </div>
    </FilterLayout>
</template>
<script setup>
import FilterLayout from "./layout/index.vue"
import AddressSection from "./component/AddressSection.vue";
import OsmSection from "./component/OsmSection.vue";
import DateRange from "./component/DateRange.vue";
import { reactive, onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { getAllowActionByCurrRole } from "@/utils/get-roles"

const INIT_FILTER_VALUE = {
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  advance_filter: false,
  osm: null,
  start_date: null,
  end_date: null
};
const filterByDate = ref([])

const store = useStore();
const filterState = reactive({ ...INIT_FILTER_VALUE });
const selectedLevel = ref("จังหวัด")

onMounted(() => {
  Object.assign(
    filterState,
    JSON.parse(JSON.stringify(store.getters["reportProblemFilter/getAllFilter"]))
  );
  if(filterState.start_date && filterState.end_date)
    filterByDate.value = [filterState.start_date, filterState.end_date]

  if(filterState.address.province)
    selectedLevel.value = "จังหวัด"
  else if(filterState.osm)
    selectedLevel.value = "สสว."
});


const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE))
  initFilter.address.province = filterState.address.province
  Object.assign(filterState, initFilter);
  filterByDate.value = []
};
const sendToStore = () => {
  filterState.start_date = filterByDate.value?.length > 1 ? filterByDate.value[0].toISOString().split('T')[0] : null
  filterState.end_date = filterByDate.value?.length > 1 ? filterByDate.value[1].toISOString().split('T')[0] : null
  store.dispatch(
    "reportProblemFilter/setStore",
    JSON.parse(JSON.stringify(filterState))
  );
};
const updateAddress = (evt, key) => {
  filterState.address[key] = evt;
};
watch(()=> selectedLevel.value, (val)=>{
  if(val == "สสว."){
    filterState.address = {
      amphur: null,
      province: null,
      tumbol: null,
      village: null,
    }
  }
  else{
    filterState.osm = null
  }
})
const getUserRoleCode = computed(()=>{
  if(store.getters["userAuth/getUserRoleCode"]){
    return store.getters["userAuth/getUserRoleCode"]
  }
  else{
    return null
  }
})
</script>